import { Component, OnInit,ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import * as moment from 'moment/moment';
import {ToastyService, ToastOptions, ToastData} from 'ng2-toasty';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertComponent } from './../alert/alert.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { Popup } from 'ng2-opd-popup';
import { GooglePlaceDirective } from "ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive";
import { Address } from "ngx-google-places-autocomplete/objects/address";

@Component({
  selector: 'app-emirates',
  templateUrl: './emirates.component.html',
  styleUrls: ['./emirates.component.scss']
})
export class EmiratesComponent implements OnInit {
	ToolTip="Delete is not allowed since it is used in Sublocality page";
	loading:boolean=true;
	msgtext:string="";
	Emiratecolor:any='#000000';
	emirate:string='';
	isValid:boolean=false;
	inputvalidate:boolean=false;//newMake_err
	ListEmiratesdetails:any[]=[];
	editobjid:any;
	orgId:number;
	userId:number;
	alerttxt:any;//msgtxt
	btnName='Submit';
	p:number=1;
	startingCount:number = 0;
	endingCount:number = 0;
	search:any;
	isEmiratesListLoaded:boolean=false;
	isDeleteAvailabilityLoaded:boolean=false;
	@ViewChild("placesRef") placesRef: GooglePlaceDirective;
	@ViewChild('add') add: Popup;
	@ViewChild('update') update: Popup;
	@ViewChild('Askdelete') Askdelete: Popup;
	@ViewChild('delete') delete: Popup;
	lat:any;
	lng:any;
	deleteId:any;
  	constructor(private dialogservice:DialogService, private router:Router,private route : ActivatedRoute,private http:Http,private toastyservice:ToastyService) { }

  	ngOnInit() {
		this.loading = true;
		this.isEmiratesListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
  		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	        window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
	    }
		this.getemiratesdetails();
  	}

  	onAddressSearchChange(address: Address) { //google address search and zoom the address
		if(!address || !address.address_components || address.address_components.length === 0) {
			return;
		}

		this.emirate=address.address_components[0].long_name;
        this.lat = address.geometry.location.lat();
        this.lng = address.geometry.location.lng();
        this.validate(this.emirate);
    }

  	addOk() {
		this.add.hide();
	}

	updateOk() {
		this.update.hide();
	}

	deleteOk() {
		this.delete.hide();
	}

	validate(val) {
		if(this.sanitizeEmirateName(this.emirate) === ''){
			this.inputvalidate=true;
			this.isValid=false;
		}else{
		  this.inputvalidate=false; 
		  this.isValid=true;
		}
	}

	updateLoadingState() {
		this.loading = !(this.isEmiratesListLoaded && this.isDeleteAvailabilityLoaded);
	}

	sanitizeEmirateName(value:any): string {
		return String(value || '').trim().toLowerCase();
	}

	showDuplicateDialog(message:string, title:string) {
		this.dialogservice.addDialog(AlertComponent,{title:title,message:message});
	}

  	showAlertforAddingData(){
  		this.dialogservice.addDialog(AlertComponent,{title:"ADD DISTRICT", message:"The Data is added successfully"})

	}
	showAlertforUpdatingData(){
		this.dialogservice.addDialog(AlertComponent,{title:"UPDATE DISTRICT",message:"The Data is updated successfully"})
	}
	showAlertforDeletingData(){
		this.dialogservice.addDialog(AlertComponent,{title:"DELETE DISTRICT",message:"The Data is deleted successfully"})
	}
	getemiratesdetails(){
		this.loading = true;
		this.isEmiratesListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
		let emiratesObj = {
			'orgId':this.orgId
		}
		return this.http.post("/api/getEmiratesdetails",emiratesObj).subscribe(res=>{
			    
			let responseEmirates=res.json();
			this.ListEmiratesdetails=(responseEmirates.result_data || []).map((emiratesDetail:any) => ({
				...emiratesDetail,
				status:false,
				deleteBlockedReason:''
			}));
			if(this.ListEmiratesdetails.length>0){
				console.log(responseEmirates);
				this.getCount();
				this.empty();
				this.isEmiratesListLoaded = true;
				this.loadDeleteAvailability();
			}else{
	        		this.isEmiratesListLoaded = true;
	        		this.isDeleteAvailabilityLoaded = true;
	        		this.updateLoadingState();
			}
		
		},err=>{
			this.isEmiratesListLoaded = true;
			this.isDeleteAvailabilityLoaded = true;
			this.updateLoadingState();
			if(err.status!=200){
				this.alerttxt="Unable to load the Emirates value";
				this.getWarningFunction(this.alerttxt);
			}
		})
}

	loadDeleteAvailability() {
		let emiratesIds:any[] = [];

		for(let i=0;i<this.ListEmiratesdetails.length;i++){
			this.ListEmiratesdetails[i].status = false;
			this.ListEmiratesdetails[i].deleteBlockedReason = '';
			emiratesIds.push(this.ListEmiratesdetails[i]._id);
		}

		return this.http.post('/api/getEmiratesDeleteAvailability', {
			'ids':emiratesIds,
			'orgId':this.orgId
		}).subscribe(res => {
			let availabilityResponse = res.json().availability || {};

			for(let i=0;i<this.ListEmiratesdetails.length;i++){
				if(availabilityResponse[String(this.ListEmiratesdetails[i]._id)] && availabilityResponse[String(this.ListEmiratesdetails[i]._id)].canDelete === false){
					this.ListEmiratesdetails[i].status = true;
					this.ListEmiratesdetails[i].deleteBlockedReason = availabilityResponse[String(this.ListEmiratesdetails[i]._id)].reason || this.ToolTip;
				}
			}

			this.isDeleteAvailabilityLoaded = true;
			this.updateLoadingState();
		},err => {
			this.isDeleteAvailabilityLoaded = true;
			this.updateLoadingState();
			if(err.status!=200){
				this.msgtext = "Unable to validate delete availability";
				this.getWarningFunction(this.msgtext);
			}
		})
	}

	getCount(){
	    if(this.p < Math.ceil(this.ListEmiratesdetails.length/10)){
	      this.startingCount = (this.p-1)*10;
	      if(this.startingCount == 0){
	        this.startingCount = 1;
	      }
	      this.endingCount = this.p*10;
	    } else if(this.p == Math.ceil(this.ListEmiratesdetails.length/10)){
	      let count = this.ListEmiratesdetails.length%10;
	      this.startingCount = (this.p-1)*10;
	      this.endingCount = this.startingCount + count;
	      if(this.startingCount == 0){
	        this.startingCount = 1;
	        this.endingCount = count;
	      }
	    }
   	}


    reset(){
		this.empty();
	}

	empty(){
		this.emirate="";
		this.editobjid="";
		this.inputvalidate=false;
		this.Emiratecolor="#000000";
		this.btnName='Submit';
		this.isValid=false;
		this.lat = null;
		this.lng = null;
	}

   



	onsubmit(){
		let sanitizedEmirate = this.sanitizeEmirateName(this.emirate);
		this.loading = true;

		if(sanitizedEmirate === ''){
		    this.inputvalidate=true;
			this.isValid=false;
			this.loading = false;
		    document.body.scrollTop = 0;
    		document.documentElement.scrollTop = 0;
		}else {//add branch details
		  if(this.editobjid == null || this.editobjid == undefined || this.editobjid == "") {
		   	let reqbranchobj={
				'emirates':sanitizedEmirate,
				'orgId':this.orgId,
				'latitude':this.lat,
				'longitude':this.lng,
				'color':this.Emiratecolor,
				'created_By':this.userId,
				'created_Date': moment.utc().format('YYYY:MM:DD h:mm:ss')
			}

			return this.http.post('/api/addemirates',reqbranchobj).subscribe(res=>{
			  	let branchresponse=res.json()

			  	if(branchresponse.message=="This Emirates Already Exists"){
			    	this.loading = false;
			    	this.showDuplicateDialog('This Emirates Already Exists','ADD DISTRICT');
				} else if(branchresponse.message=="This Color Already Exists") {
					this.loading = false;
					this.showDuplicateDialog('This Color Already Exists','ADD DISTRICT');
				}else{
					this.getemiratesdetails();
				 	this.showAlertforAddingData();
				}
			},err=>{
				this.loading = false;
			  	if(err.status!=200){
					this.alerttxt="Unable to add the emirates value";
					this.getWarningFunction(this.alerttxt);
				}
			})
		} else{
		    let reqbranchobj={
		      'emirates':sanitizedEmirate,
		      'orgId':this.orgId,
		      'latitude':this.lat,
				'longitude':this.lng,
				'color':this.Emiratecolor,
		      'updated_By':this.userId,
		      'updated_Date':moment.utc().format('YYYY:MM:DD h:mm:ss'),
		      'objectId':this.editobjid
		    }
		
		    return this.http.post("/api/updateEmiratesdetails",reqbranchobj).subscribe(res=>{
				    
		        let branchresponse=res.json();
				if(branchresponse.message=="This Emirates Already Exist"){
					this.loading = false;
					this.showDuplicateDialog('This Emirates Already Exists','UPDATE DISTRICT');
			} else if(branchresponse.message=="The Emirates Color Already Exist") {
				this.loading = false;
				this.showDuplicateDialog('The Emirates Color Already Exist','UPDATE DISTRICT');
			}else{
		      		
				    this.getemiratesdetails();
					// this.update.options={
				  // 		showButtons: false, // You can hide this in case you want to use custom 
				  //   	color: "#4180ab",
				  //   	header: "Update Emirates"
					// }
					// this.update.show(this.update.options);
					this.showAlertforUpdatingData();
	      		}
	    	},err=>{
				this.loading = false;
		        
		      	if(err.status!=200){
			        this.alerttxt="Unable to update the emirates Value",
			        this.getWarningFunction(this.alerttxt);
		      	}
		    })}
		}
	}

	// Editing(index, objectId) {
	// 	this.empty();
 //    	this.editobjid = objectId;
 //  		this.btnName = 'Update';
	// 	this.emirate = this.ListEmiratesdetails[index].emirates.toUpperCase();
 //   	}

   	Editing(index, objectId) {
  		this.empty();
        this.editobjid = objectId;
        this.btnName = 'Update';
	this.isValid = true;
        this.emirate = this.ListEmiratesdetails[index].emirates.toUpperCase();
        for(let getdes of this.ListEmiratesdetails) {
		    if(getdes._id == objectId ) {
					 this.emirate = getdes.emirates.toUpperCase();
					 this.Emiratecolor=getdes.color;
					 this.lat=getdes.latitude;
					 this.lng=getdes.longitude;
		    }
  		}
    }	
	Delete(index, deleteId) {
		if(this.ListEmiratesdetails[index] && this.ListEmiratesdetails[index].status === true) {
			this.msgtext = this.ListEmiratesdetails[index].deleteBlockedReason || this.ToolTip;
			this.getWarningFunction(this.msgtext);
			return false;
		}

		this.reset();
		this.deleteId = deleteId;
		this.Askdelete.options = {
	        showButtons: false, // You can hide this in case you want to use custom 
	        color: "#4180ab",
	        header: "Delete Emirate"
	    };
	    this.Askdelete.show(this.Askdelete.options);
	}
	No() {
		this.Askdelete.hide();
	}

	Yes() {
		this.Askdelete.hide();
		this.loading = true;
		
		let reqMakeObj = {
	        'deleteId':this.deleteId,
			'orgId':this.orgId
	    }
	    return this.http.post('/api/deleteEmiratesDetails', reqMakeObj).subscribe(
	      res => {
			let emirateResponse = res.json();
			if(emirateResponse && emirateResponse.canDelete === false) {
				this.loading = false;
				this.msgtext = emirateResponse.reason || this.ToolTip;
				this.getWarningFunction(this.msgtext);
				this.deleteId="";
				this.getemiratesdetails();
				return;
			}
			
			this.showAlertforDeletingData();
			this.deleteId="";
	      this.getemiratesdetails();
	    },(err)=>{
			this.loading = false;
	       
	        this.msgtext = "Unable to delete the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}


  	getWarningFunction(err){
	    var toastOptions:ToastOptions={
	      title: "Branch",
	      msg: err,
	      showClose: true,
	      timeout: 3000,
	      theme: 'bootstrap',
	      onAdd: (toast:ToastData) => {
	      },
	      onRemove: function(toast:ToastData) {
	      }
	  	};
		this.toastyservice.warning(toastOptions);
	}
    
  	getSuccessFunction(success){
	    var toastoptions:ToastOptions={
	      title:"Branch",
	      msg:success,
	      showClose:true,
	      timeout:3000,
	      theme:'bootstrap',
	      onAdd:(toast:ToastData)=>{
		},
		onRemove: function(toast:ToastData) {
		}
	    };
    	this.toastyservice.success(toastoptions);
  	}

}



// WEBPACK FOOTER //
// ./client/app/emirates/emirates.component.ts